const subscriptionInputs = document.querySelectorAll('.product__content .shopify_subscriptions_fieldset input[type="radio"]');
const subscriptionLabels = document.querySelectorAll('.product__content  .shopify_subscriptions_app_block_label');


function updateCheckedState() {
    const blocks = document.querySelectorAll('.shopify_subscriptions_app_block_label');

    blocks.forEach(block => {
        const inputsInBlock = block.querySelectorAll('input[type="radio"]');
        
        const isChecked = Array.from(inputsInBlock).some(input => input.checked);
        
        if (isChecked) {
            block.classList.add('active');
        } else {
            block.classList.remove('active');
        }


        inputsInBlock.forEach(input => {
            const parentLabel = input.closest('label');
            if (input.checked) {
                parentLabel.classList.add('checked');
            } else {
                parentLabel.classList.remove('checked');
            }
        });
    });
}

updateCheckedState();

subscriptionInputs.forEach(input => {
    input.addEventListener('change', updateCheckedState);
});





const subscriptionsContainer = document.querySelector('.shopify_subscriptions_app_container');
const subscribeDescription = document.querySelector('.product__block.subscribe-description');
const priceContainer = document.querySelector('.product__price__block');

if (subscriptionsContainer) {
    subscribeDescription.classList.remove('hidden');
    subscribeDescription.classList.add('visible');
    priceContainer.classList.remove('visible');
    priceContainer.classList.add('hidden');
} else {
    subscribeDescription.classList.remove('visible');
    subscribeDescription.classList.add('hidden');
    priceContainer.classList.remove('hidden');
    priceContainer.classList.add('visible');
}









